export const getAvatars = (index: number) => new URL(`../assets/images/avatar/${index}.png`, import.meta.url).href
